<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :model="model"
      entity-name="Room"
      icon="mdi-cash-plus"
    >
      <template #item.imagesDisplay="{item}">
        <div style="display: flex;">
          <img
            v-for="(image, index) in splitFile(item.images)"
            :key="index"
            :src="image"
            alt="Image"
            style="width: 25px; height: 25px; margin-right: 5px;"
          >
          <v-icon @click.stop="startEditTableImage(item)">
            mdi-plus-circle-outline
          </v-icon>
        </div>
      </template>
      <template #primaryButton>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="showMassAddTableDialog = true"
        >
          <div
            class="d-flex align-center"
          >
            <v-icon
              left
            >
              mdi-plus-circle-outline
            </v-icon>
            <template>
              <div
                class="text-truncate"
                style="max-width: 80px !important;"
              >
                添加包厢
              </div>
            </template>
          </div>
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showMassAddTableDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="text-h4 font-weight-bold">
          添加包厢
        </div>
        <div class="d-flex my-4">
          <v-card
            color="grey lighten-4"
            elevation="0"
            height="72"
            width="72"
            @click.stop="$refs.file.$refs.input.click()"
          >
            <v-icon
              class=" lighten-4 rounded-lg"
              style="position: absolute;right: 0;bottom: 0;top: 0;left: 0;margin: auto"
              x-large
            >
              mdi-plus
            </v-icon>
          </v-card>
          <div class="d-flex">
            <v-card
              v-for="(url,index) in uploadUrls"
              :key="index"
              class="d-flex align-center justify-center"
              elevation="0"
              height="72"
              outlined
              width="72"
            >
              <div style="width: 100%">
                <img-with-loading
                  :height="'72px'"
                  :img-src="url"
                  :width="'72px'"
                />
                <v-btn
                  absolute
                  bottom
                  color="primary"
                  fab
                  icon
                  style="right: -12px"
                  x-small
                  @click.stop="deletePic(index)"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
            </v-card>
          </div>
        </div>

        <v-file-input
          ref="file"
          v-model="filesStore"
          accept="image/*"
          dense
          hide-details
          multiple
          outlined
          prepend-icon=""
          style="height: 0;opacity: 0"
        />
        <div class="text-overline">
          包厢名称
        </div>
        <v-text-field
          v-model="tableName"
          :placeholder="'包厢名称'"
          class="text-uppercase"
          outlined
        />
        <div class="text-overline">
          {{ $t('tableNumberOfPeople') }}
        </div>
        <v-text-field
          v-model="seatCount"
          class="text-uppercase"
          outlined
          type="number"
        />
        <v-btn
          :disabled="!tableName"
          :loading="loading"
          block
          color="amber lighten-4 black--text"
          elevation="0"
          @click="addTable"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editTableImageDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="text-h3 font-weight-bold">
          # {{ editItem?.name }}
        </div>
        <div
          style="display: grid;grid-template-columns: repeat(auto-fill,minmax(144px,1fr));grid-gap: 24px;"
        >
          <v-card
            class="pa-4 d-flex align-center justify-center"
            color="#eee"
            elevation="0"
            height="200"
          >
            <div class="text-center">
              <v-icon size="48">
                mdi-plus
              </v-icon>
              <div>
                {{ $t('AddNewFile') }}
              </div>
            </div>
            <v-file-input
              ref="input"
              multiple
              outlined
              style="opacity: 0; position: absolute; width: 100%; height: 200px; bottom: -70px; "
              type="file"
              @change="choseFile"
            />
          </v-card>
          <div
            v-for="(item,index) in splitFile(editItem?.images)"
            :key="index"
          >
            <v-card
              :img="item"
              elevation="0"
              height="200"
              outlined
              @click="downloadFile(item)"
            >
              <div
                class="fill-height image-style d-flex flex-column"
              >
                <div />
                <v-spacer />
                <div class="d-flex align-center justify-center">
                  <v-spacer />
                  <div>
                    <v-btn
                      icon
                      @click.stop="deleteFiles(item)"
                    >
                      <v-icon color="white">
                        mdi-delete-outline
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import Section from '../../../../model/dataLayer/api/tableAndPerson/Section'
import Table from '@/model/dataLayer/api/tableAndPerson/Table'
import { showSuccessMessage } from '@/model/utils/utils'
import { saveFiles, saveFilesWithArr } from '@/model/dataLayer/api/newReservation/reservationTable'
import RoomSection from '@/model/dataLayer/api/tableAndPerson/RoomSection'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import RoomTable from '@/model/dataLayer/api/tableAndPerson/RoomTable'
import ImgWithLoading from '@/plugins/EntityFrameWork/Base/ImgWithLoading.vue'
import imageCompression from 'browser-image-compression'

export default {
  components: {
    ImgWithLoading,
    IkDataTable
  },
  data: function () {
    return {
      usePic: [],
      filesStore: null,
      editItem: null,
      editTableImageDialog: false,
      mainPageLoading: false,
      waitLoading: false,
      sectionList: [],
      tableList: [],

      model: RoomTable,
      sectionModel: RoomSection,

      showMassAddTableDialog: null,
      startTableNumber: null,
      endTableNumber: null,

      showEditTableDialog: null,
      editTableId: null,
      tableName: '',
      seatCount: 4,

      activeSectionIndex: null,
      activeSectionId: null,
      showAddSectionDialog: null,
      sectionName: '',
      editSectionId: null,
      loading: false,

      showChangeSectionDialog: null,
      selectedTableList: []

    }
  },
  mounted () {
    this.reloadData()
  },
  watch: {
    async filesStore (val) {
      const options = {
        maxSizeMB: 1,
        useWebWorker: true
      }
      const files = []
      for (const file of val) {
        if (typeof file !== 'string') {
          files.push(await imageCompression(file, options))
        } else {
          files.push(file)
        }
      }
      this.usePic = this.usePic.concat(files)
    }
  },
  computed: {
    uploadUrls: function () {
      const arr = []
      for (const item of this.usePic) {
        if (typeof item !== 'string') {
          arr.push(URL.createObjectURL(item))
        } else {
          arr.push(item)
        }
      }
      return arr
    }
  },
  methods: {
    deletePic (index) {
      this.usePic.splice(index, 1)
    },
    splitFile (images) {
      return images ? images.split(',') : []
    },
    async deleteFiles (item) {
      this.editItem.images = this.splitFile(this.editItem.images).filter(it => it !== item).join(',')
      await Table.edit(this.editItem)
      showSuccessMessage(this.$i18n.t('DeletionSuccessful'))
    },
    async downloadFile (item) {
      window.open(item)
    },
    async choseFile (event) {
      const newFiles = await saveFiles(event)
      this.editItem.images = this.editItem.images + ',' + newFiles
      await Table.edit(this.editItem)
      await this.reloadData()
    },
    startEditTableImage (table) {
      this.editItem = table
      this.editTableImageDialog = true
    },
    async actionAnd (action) {
      this.loading = true
      try {
        await action()
        await this.reloadData()
        showSuccessMessage()
      } catch (e) {

      }

      this.loading = false
    },
    async addTable () {
      await this.actionAnd(async () => {
        await Table.add({
          description: '',
          images: await saveFilesWithArr(this.usePic),
          isnumber: '1',
          letter: '0',
          minConsumePrice: '0',
          name: this.tableName,
          pricePer15Min: '0',
          seatCount: this.seatCount,
          sectionId: this.activeSectionId,
          tableType: 'Room',
          totalPrice: '0',
          usageCount: '0',
          usageStatus: '0'
        })
      })
      this.startTableNumber = null
      this.endTableNumber = null
      this.showMassAddTableDialog = false
      await this.$refs.table.reload()
    },

    async reloadData () {
      this.mainPageLoading = true
      this.waitLoading = false
      await this.reloadSection()
      await this.reloadTable()
      this.waitLoading = true
      this.mainPageLoading = false
    },
    async reloadTable () {
      this.tableList = (await Table.getList(true)).filter(it => it.tableType === 'Room')
      this.selectedTableList = []
    },
    async reloadSection () {
      const oldId = this.activeSectionId
      this.sectionList = (await Section.getList(true)).filter(it => it.id !== 6).filter(it => it.tableType === 'Room')
      if (this.sectionList.length > 0) {
        if (!this.sectionList.find(it => it.id === oldId)) {
          this.activeSectionId = this.sectionList[0].id
        }
      } else {
        await Section.add({ name: 'Room', tableType: 'Room' })
        await this.reloadSection()
      }
    }
  }
}
</script>

<style>
.image-style {
  background: rgb(43, 44, 49);
  background: linear-gradient(0deg, rgba(43, 44, 49, 1) 0%, rgba(43, 44, 49, 1) 20%, rgba(43, 44, 49, 0.8) 25%, rgba(43, 44, 49, 0.6) 30%, rgba(43, 44, 49, 0) 50%, rgba(43, 44, 49, 0) 100%);
}
</style>
